<template>
  <symbol
    id="times"
    viewBox="0 0 14 14"
  >
    <path
      d="M8.06066 7L13.5303 1.53033L12.4697 0.469666L7 5.93934L1.53033 0.469666L0.469666 1.53033L5.93934 7L0.469666 12.4697L1.53033 13.5303L7 8.06066L12.4697 13.5303L13.5303 12.4697L8.06066 7Z"
    />
  </symbol>
</template>
